import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as commonActions from '@common/common.action';
import CommonFunctions from '@common/util/functions.common';
import { Container, Badge } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import WebapiCommon from '@common/util/webapi.common';
import { colorsSystem } from '@common/util/defaultValues';
import IntlMessage from '../../../../helpers/intlMessage';

function LaminasCitologia ({ laudo }) {
  const dispatch = useDispatch();
  const [lista, setLista] = useState([]);

  useEffect(() => {
    laudo && getLaminas(laudo);
  }, [laudo]);

  const returnColor = status => {
    switch (status) {
      case 'Finalizado':
        return colorsSystem.VERDE;
      case 'Pendente':
        return colorsSystem.AMARELO;
      default:
        return colorsSystem.VERMELHO;
    }
  };

  const returnStatusText = status => {
    switch (status) {
      case 'Finalizado':
        return 'Pronta';
      default:
        return status;
    }
  };

  const nrLaminaFormatted = (item) => {
    return (
      <span>
        {`${item.lamina} `}
        {item.cancelada && (
          <Badge style={{fontSize: '10px', backgroundColor: '#f15959', color: '#fff'}}>
            CANCELADA
          </Badge>
        )}
      </span>
    )
  }

  const statusFormatted = (item) => {
    return (
      <Badge style={{fontSize: '12px', backgroundColor: returnColor(item.finalizacao), color: `${item.finalizacao === 'Pendente' ? '#333' : '#fff'}`}}>
        {returnStatusText(item.finalizacao)}
      </Badge>
    )
  }

  const getLaminas = laudoId => {
    dispatch(commonActions.showFadeCarregando(true));

    WebapiCommon.getLaminasCitologia('', '', '', '', laudoId).then(resp => {
      const dataFormated = resp.map(item => ({
        ...item,
        // laminaFormated: (
        //   <span>
        //     {`${item.lamina} `}
        //     {item.cancelada && (
        //       <Badge
        //         style={{
        //           fontSize: '10px',
        //           backgroundColor: '#f15959',
        //           color: '#fff'
        //         }}
        //       >
        //         CANCELADA
        //       </Badge>
        //     )}
        //   </span>
        // ),
        dataCadastro: CommonFunctions.formatDateHour(item.dataCadastro),
      }));
      setLista(dataFormated);
      dispatch(commonActions.showFadeCarregando(false));
    });
  };
  return (
    <Container fluid className='mv-workspace-container'>
      <DataTable
        value={lista}
        responsive={true}
        selectionMode='single'
        style={{ height: '100%' }}
        columnResizeMode='expand'
        scrollable={true}
        scrollHeight='71vh'
        scrollWidth='100%'
        resizableColumns={true}
        reorderableColumns={true}
        rowsPerPageOptions={[10, 20, 50]}
        lazy={false}
        paginator={false}
        emptyMessage={<IntlMessage id = "dashboards.examDetail.table.noResultsFound"/>}
        alwaysShowPaginator={true}
        autoLayout={true}
        totalRecords={lista.length}
        onSelectionChange={e => {}}
      >
        <Column
          sortable={true}
          field='lamina'
          style={{ width: '250px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.blade"/>}
          body={nrLaminaFormatted}
        />
        <Column
          sortable={true}
          field='citoTecnicoDelegado'
          style={{ width: '200px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.delegateTechnician"/>}
        />
        <Column
          sortable={true}
          field='exame'
          style={{ width: '180px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.exam"/>}
        />
        <Column
          sortable={true}
          field='finalizacao'
          style={{ width: '120px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.status"/>}
          body={statusFormatted}
        />
        <Column
          sortable={true}
          field='dataCadastro'
          style={{ width: '150px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.registrationDate"/>}
        />
      </DataTable>
    </Container>
  );
}

export default LaminasCitologia;



// WEBPACK FOOTER //
// ./src/pages/main/ControleBlocosLaminas/LaminasCitologia/index.js